import useMediaQuery from "../../../../hooks/useMediaQuery";
import { useTanstack } from "../../../../hooks/useTanstack";
import Skeleton from "../../../../components/ui/skeleton";
import { Link } from "react-router-dom";
import { SubTitle } from "../../../../components/ui/typography/subTitle";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import { isValidUrl } from "../../../../utils/checkers";
import styles from "./services.module.scss";

export const Services = () => {
  const { data } = useTanstack("getWebServices");

  const laptopSmall = useMediaQuery(`( max-width: 1099px )`);
  const mobile = useMediaQuery(`( max-width: 768px )`);

  const skeletonCount = laptopSmall && !mobile ? 2 : 3;

  return (
    <div className={styles.services}>
      <div className="container">
        <div className={styles.services_top}>
          <SubTitle text="services" />
        </div>

        {/* {!data ? (
          <Skeleton type="service" number={skeletonCount} />
        ) : (
          <div className={styles.services_swiper}>
            <Swiper
              spaceBetween={30}
              pagination={{
                clickable: true,
              }}
              speed={1000}
              loop={false}
              modules={[Navigation]}
              navigation={true}
              className={styles.services_row}
              updateOnWindowResize={false}
              breakpoints={{
                1100: {
                  slidesPerView: 3,
                },
                768: {
                  slidesPerView: 2,
                },
                0: {
                  slidesPerView: 1,
                },
              }}
            >
              {data?.map(({ id, img, title, description, url }) => {
                return (
                  <SwiperSlide key={id} title={description}>
                    <Link
                      to={url}
                      target={isValidUrl(url) ? "_blank" : undefined}
                      className={styles.services_col}
                    >
                      <img src={img} alt={`icon${id}`} />
                      <div className={styles.services_col_context}>
                        <h4>{title}</h4>
                        <p>{description}</p>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )} */}

        {!data ? (
          <Skeleton type="service" number={skeletonCount} />
        ) : (
          <div className={styles.services_swiper}>
            {mobile ? (
              <div className={styles.services_row}>
                {data.map(({ id, img, title, description, url }) => (
                  <Link
                    key={id}
                    to={url}
                    target={isValidUrl(url) ? "_blank" : undefined}
                    className={styles.services_col}
                  >
                    <img src={img} alt={`icon${id}`} />
                    <div className={styles.services_col_context}>
                      <h3>{title}</h3>
                      <p>{description}</p>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <Swiper
                spaceBetween={30}
                pagination={{ clickable: true }}
                speed={1000}
                loop={false}
                modules={[Navigation]}
                navigation={true}
                className={styles.services_row}
                updateOnWindowResize={false}
                breakpoints={{
                  1100: { slidesPerView: 3 },
                  768: { slidesPerView: 2 },
                }}
              >
                {data.map(({ id, img, title, description, url }) => (
                  <SwiperSlide key={id} title={description}>
                    <Link
                      to={url}
                      target={isValidUrl(url) ? "_blank" : undefined}
                      className={styles.services_col}
                    >
                      <img src={img} alt={`icon${id}`} />
                      <div className={styles.services_col_context}>
                        <h3>{title}</h3>
                        <p>{description}</p>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
